import { createContext } from 'react'

export type ThemeVariant = 'light' | 'dark'

export type ThemeContextState = {
  themeVariant: ThemeVariant
  toggleThemeVariant: () => void
}

const ThemeContext = createContext<ThemeContextState | undefined>(undefined)

export default ThemeContext
